import { useState } from 'react'
import { colors, glyphs } from '../../Styles';
import { PrimaryPopover } from '..';

interface EventNotePopover_Props {
  eventName: string
  eventNote?: string
  glyphColor?: colors
}
/**
 * EventNotePopover
 * @param selectedAnimal
 * @returns
 */
export default function EventNotePopover({eventName, eventNote, glyphColor}:EventNotePopover_Props) {
  const [, setIsOpen] = useState(false)

  return ( <>
    <PrimaryPopover
      content={ <div onClick={() => setIsOpen(true)} style={{width: "fit-content", height: "fit-content", margin: "-5px 0px", cursor: "pointer"}}>
        <glyphs.Note fillColor={glyphColor}/>
      </div> } 
      popoverHeader={eventName} 
      popoverContent={ <>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
          {eventNote}
        </div>
      </> } 
    />
  </> )
}

export const formatDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};